import Vue from 'vue';
import $ from 'jquery';
import NewsFilter from "./NewsFilter";

function getOptions($select) {
    const options = [];
    $select.children('option').each((i, o) => {
        const $o = $(o);
        options.push({
            value: $o.attr('value'),
            label: $o.text(),
        })
    });
    return options;
}

function getLabel($select) {
    const id = $select.attr('id');
    return $(`label[for="${id}"]`).first().text();
}

function getSelectedValue($select) {
    return $select.children('option:selected').first().attr('value');
}

export default function initFilters($form) {
    $form.hide(); // We want to always hide it.

    const $newsFilterElement = $('#news-filter').first();
    if ($newsFilterElement.length > 0) {

        const label = $newsFilterElement.text();

        // we clear the text on the page, as we will use this place to hook our filters in mobile view
        // and we use the text as a label so it should not appear in dom.
        $newsFilterElement.text('');

        const selects = [
            $form.children('#news-filter-area').first(),
            $form.children('#news-filter-categories').first(),
            // $form.children('#news-filter-type').first(), // removed per client request
        ];

        const newsFiltersVM = new Vue({
            data() {
                return {
                    values: selects.map(select => getSelectedValue(select)),
                };
            },
            render(h) {
                return h(NewsFilter, {
                    props: {
                        labels: selects.map($select => getLabel($select)),
                        options: selects.map($select => getOptions($select)),
                        values: this.values,
                        buttonLabel: label,
                    },
                    on: {
                        select: this.select,
                    },
                });
            },
            methods: {
                select([value, index]) {
                    Vue.set(this.values, index, value);
                    selects[index].val(value);
                    $form.submit();
                }
            }
        });

        newsFiltersVM.$mount();

        // 0 - not placed, 1 - directly in content__container, -1 - inside #news-filter
        let position = 0;

        // Either add to dom into filters element or append as first child to content__container
        // depending if it is viewed on mobile or on desktop
        // this is done due to the animation that is making fixed positioning of this element impossible on
        // large viewports and to avoid it jumping we append as first child it to content__container if we are viewing on desktop.
        // In first version, it was append to body, 
        // but then to focus button by keyboard navigation, we had to go through all the news on the list.
        function placeOnContent() {
            if ($(window).width() >= 1080 && position <= 0) {
                $('.content__container').prepend(newsFiltersVM.$el);
                position = 1;
            } else if (position >= 0) {
                $newsFilterElement.append(newsFiltersVM.$el);
                position = -1;
            }
        }

        placeOnContent();
        window.addEventListener('resize', placeOnContent, { passive: true });

    }

}
